import React from 'react';
import { Row, Stack, Text } from 'library/ui';
import { Colors } from 'library';
import styled from '@mui/material/styles/styled';

export default function Holiday({ holidays }: { holidays: { name: string; date: string }[] }) {
    return (
        <>
            {holidays.map((holiday) => (
                <Stack key={holiday.name} padding="none">
                    <HolidayRow justify="center">
                        <Text tone="overlay" weight="bold">
                            {holiday.name}
                        </Text>
                    </HolidayRow>
                </Stack>
            ))}
        </>
    );
}

const HolidayRow = styled(Row)({
    backgroundColor: Colors.secondary,
    width: '100%',
    padding: '2px 8px',
    borderTop: `1px solid ${Colors.border}`,
});
